<script setup>
</script>

<template>
  <h3 class="cloud-calculator__summary-title">
    {{ $Bitrix.Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_TITLE') }}
  </h3>
</template>
